export function Industry(
  props: React.SVGAttributes<SVGSVGElement>
): React.ReactElement {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.5 4.375H15V3.125C15 1.74414 13.8809 0.625 12.5 0.625H7.5C6.12109 0.625 5 1.74414 5 3.125V4.375H2.5C1.11914 4.375 0 5.49609 0 6.875V16.875C0 18.2559 1.11914 19.375 2.5 19.375H17.5C18.8809 19.375 20 18.2559 20 16.875V6.875C20 5.49609 18.8789 4.375 17.5 4.375ZM7.5 2.5H12.5C12.8452 2.5 13.125 2.7798 13.125 3.125V4.375H6.875V3.125C6.875 2.77969 7.15625 2.5 7.5 2.5ZM2.5 6.25H17.5C17.8438 6.25 18.125 6.53125 18.125 6.875V10.625H1.875V6.875C1.875 6.53125 2.15625 6.25 2.5 6.25ZM17.5 17.5H2.5C2.15625 17.5 1.875 17.2188 1.875 16.875V12.5H7.5V13.125C7.5 13.8152 8.05977 14.375 8.75 14.375H11.25C11.9402 14.375 12.5 13.8152 12.5 13.125V12.5H18.125V16.875C18.125 17.2188 17.8438 17.5 17.5 17.5Z"
        fill="black"
      />
    </svg>
  );
}
